(function () {
  'use strict';

  /* @ngdoc object
   * @name country
   * @description
   *
   */
  angular
    .module('wbCountry', [
    ]);
}());
